import TableRowList from './TableRowList';
import { TableRowListProps, TableRowListValueProps } from './types';

export type { TableRowListProps, TableRowListValueProps };
export default TableRowList;
